function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}

//
docReady(() => {
//
    jQuery(function ($) {
//
//         const compareButton = document.getElementById('compare-button');
//         const comparePopup = document.getElementById('compare-popup');
//         const comparePopupInner = document.getElementById('compare-popup-inner');
//         const comparePopupClose = document.getElementById('compare-close-button');
//         const selects = document.getElementsByClassName('product-select-inner');
//
//
//         // Open Compare Popup
//         comparePopupClose.addEventListener('click', e => {
//             comparePopup.classList.add('opacity-0');
//             comparePopupInner.classList.add('opacity-0');
//             comparePopup.classList.remove('opacity-100');
//             comparePopupInner.classList.remove('opacity-100');
//             setTimeout(() => {
//                 comparePopup.classList.add('hidden');
//             }, 100)
//         });
//
//         let products = [];
//
//         compareButton.addEventListener('click', () => {
//             if (comparePopup) {
//                 comparePopup.classList.remove('hidden');
//
//                 setTimeout(() => {
//                     comparePopup.classList.remove('opacity-0');
//                     comparePopupInner.classList.remove('opacity-0');
//                     comparePopup.classList.add('opacity-100');
//                     comparePopupInner.classList.add('opacity-100');
//
//                 }, 100)
//             }
//
//             var data = {
//                 'action': 'get_products',
//             }
//
//             jQuery.ajax({
//                 url: "https://orwakdev.promoc.io/wp-admin/admin-ajax.php",
//                 data: data,
//                 type: 'POST',
//                 success: function (data) {
//                     products = data['products'];
//                     const selectedProducts = JSON.parse(window.localStorage.getItem('selectedProducts'));
//
//                     for (let select of selects) {
//                         for (const product in products) {
//                             var opt = document.createElement('option');
//                             opt.innerHTML = products[product]['post_title'];
//                             opt.value = products[product]['post_name'];
//                             select.appendChild(opt);
//                         }
//                         if (selectedProducts !== undefined && selectedProducts !== null) {
//                             const index = select.dataset.select;
//                             select.value = selectedProducts[index];
//                             let img = document.querySelector('#comparison-'+index+' img');
//                             img.src = products[selectedProducts[index]].image;
//
//                             let parent = document.querySelector('#comparison-'+index+' .product-data');
//                             parent.innerHTML = '';
//                             if (products[selectedProducts[index]].technical_data) {
//                                 for(let data of products[selectedProducts[index]].technical_data) {
//                                     createListElements(parent, data.title, data.data)
//                                 }
//                             }
//                         }
//                     }
//
//                 }
//             });
//         });
//         // End Open Compare Popup
//
//         //Compare Select Change
//
//
//         for (const select of selects) {
//             select.addEventListener('change', (e)=> {
//                 const index = parseInt(select.dataset.select, 10);
//                 const slug = select.value;
//                 let selectedProducts = JSON.parse(window.localStorage.getItem('selectedProducts'));
//                 if (selectedProducts === null) {
//                     selectedProducts = [];
//                 }
//                 selectedProducts[index] = slug;
//                 window.localStorage.setItem('selectedProducts', JSON.stringify(selectedProducts));
//
//                 let img = document.querySelector('#comparison-'+index+' img');
//                 img.src = products[slug].image;
//
//                 let parent = document.querySelector('#comparison-'+index+' .product-data');
//                 parent.innerHTML = '';
//                 if (products[selectedProducts[index]].technical_data) {
//                     for(let data of products[selectedProducts[index]].technical_data) {
//                         createListElements(parent, data.title, data.data)
//                     }
//                 }
//             })
//         }
//
//
//         //End Compare Select Change

        function addToComparison(product) {

            product.addEventListener('click', function (e) {
                e.preventDefault();
                let slug = e.target.dataset.slug;
                let selectedProducts = JSON.parse(window.localStorage.getItem('selectedProducts'));

                if (selectedProducts && !selectedProducts.includes(slug)) {
                    if (selectedProducts.length > 2) {
                        selectedProducts.pop();
                    }
                    selectedProducts.push(slug);
                } else if (selectedProducts === null) {
                    selectedProducts = [];
                    selectedProducts.push(slug);
                }


                window.localStorage.setItem('selectedProducts', JSON.stringify(selectedProducts));

                window.location.href = '/osszehasonlitas'
            });
        }


        const singleComparisonButton = document.getElementById('addToComparison');
        const archiveComparisonButtons = document.getElementsByClassName('addToComparisonCard');

        if (singleComparisonButton) {
            addToComparison(singleComparisonButton);
        }

        if (archiveComparisonButtons) {
            for (let archiveComparisonButton of archiveComparisonButtons) {
                addToComparison(archiveComparisonButton);
            }
        }

//
    });
//
//     function createListElements(parent, title, data) {
//         let row = document.createElement('div');
//         row.classList.add('row', 'flex', 'justify-between');
//         let key = document.createElement('div');
//         key.classList.add('key', 'font-bold');
//         key.innerHTML = title;
//         let value = document.createElement('div');
//         value.classList.add('value');
//         value.innerHTML = data;
//         row.appendChild(key);
//         row.appendChild(value);
//
//         parent.appendChild(row);
//     }
//
})
